<template>
  <b-container class="pt-4">
    <div class="my-referral">
      <ama-referral />
      <div class="py-2" v-if="refCode">
        <b-skeleton-table
          class="py-2"
          v-if="isBusy"
          :rows="5"
          :columns="4"
          :table-props="{ bordered: true, striped: true }"
        ></b-skeleton-table>
        <div class="t-table w-100" v-else>
          <div class="title">My Code</div>
          <div class="no-item" v-if="items.length === 0">
            <p><b-img :src="require('@/assets/images/nologo.svg')"></b-img></p>
            <p class="msg">Referral is Empty.</p>
          </div>
          <b-table
            v-else
            responsive
            class="w-100"
            thead-tr-class="t-header"
            tbody-tr-class="t-tr-row"
            primary-key="player"
            :busy.sync="isBusy"
            striped
            hover
            bordered
            :items="items"
            :fields="fields"
          >
            <template #cell(no)="{ index }"> {{ index + 1 }} </template>
            <template #cell(rate)="{ item: { rate } }">
              {{ utils.bigToCommon(rate, 2, 2) }}%
            </template>
            <template #empty="scope">
              <h4>{{ "vawn thuan" + scope.emptyText }}</h4>
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <b-modal
      id="modal-code"
      title="Generate code and rate"
      hide-footer
      centered
    >
      <b-input-group prepend="Code" class="mt-3">
        <b-form-input v-model="code"></b-form-input>
      </b-input-group>
      <b-input-group prepend="Rate" class="mt-3">
        <b-form-input
          max="100"
          v-model="rate"
          maxlength="3"
          min="0"
          type="number"
        ></b-form-input>
      </b-input-group>
      <div>
        <b-button
          variant="outline-warning"
          @click.prevent="onCreateCode"
          class="btn-create mr-2 w-100 my-3 align-items-center justify-content-center d-flex"
        >
          Generate code
          <span v-if="disabledRet" class="ml-3"
            ><b-spinner variant="light"></b-spinner
          ></span>
        </b-button>
      </div>
    </b-modal>
    <b-toast
      id="tx-error"
      toast-class="b-danger"
      title="Transaction Failed"
      solid
      auto-hide-delay="4000"
    >
      {{ message || "Your transaction was not successfully broadcasted." }}
    </b-toast>
    <b-toast
      id="tx-success"
      toast-class="b-success"
      title="Transaction Success"
      solid
      auto-hide-delay="4000"
    >
      Your transaction is successful.
    </b-toast>
  </b-container>
</template>
<script>
import { Referral } from "@/amakunicom/sdk";
import ReferralView from "@/components/Referral.vue";
export default {
  name: "ReferralPage",
  comments: {
    ReferralView,
  },
  data: () => ({
    message: null,
    loadInfo: true,
    isBusy: false,
    disabledRet: false,
    rewardPercent: 0,
    refCode: "",
    codeAP: "",
    rate: 50,
    code: "",
    fields: [
      { key: "no", label: "NO." },
      { key: "code", label: "Code" },
      { key: "rate", label: "Rate" },
      { key: "refTotal", label: "Total Referrals" },
    ],
    addr: null,
    items: [],
  }),
  async created() {
    const { chainId, referral } = this.getCoreConfig();
    this.provider = await this.getProvider(chainId);
    this.signer = await this.provider.getSigner();
    try {
      this.addr = await this.signer.getAddress();
    } catch ({ message }) {
      this.signer = null;
    }
    this.chainId = chainId;
    this.referral = new Referral(referral, this.provider, this.signer);
    this.isBusy = true;
    this.getInfo();
    if (this.addr) this.items = await this.referral.codesBy(this.addr);
    this.isBusy = false;
    if (this.$route.query.ref) {
      this.codeAP = this.$route.query.ref;
    }
  },
  methods: {
    showSuccess() {
      this.$bvToast.show("tx-success");
    },
    showError: function ({ data, message }) {
      this.message = (data && data.message) || message;
      this.$bvToast.show("tx-error");
    },
    onCreateCode: async function () {
      try {
        this.disabledRet = true;
        if (this.code) {
          const tx = await this.referral.createCode(this.code, this.rate);
          if (tx) {
            await tx.wait();
          }
          this.showSuccess();
        } else {
          this.showError({ message: "Referral code is Empty!" });
        }
      } catch (e) {
        this.showError(e);
      } finally {
        this.disabledRet = false;
      }
    },
    async onApply() {
      try {
        if (this.codeAP) {
          const tx = await this.referral.applyCode(this.codeAP);
          await tx.wait();
          this.showSuccess();
          this.getInfo();
        } else {
          this.showError({ message: "Referral code is Empty!" });
        }
      } catch (e) {
        this.showError(e);
      }
    },
    async getInfo() {
      this.loadInfo = true;
      let percent;
      [percent, this.refCode, this.rate] = await this.referral.refInfo(
        this.addr
      );
      if (percent) this.rewardPercent = percent;
      this.loadInfo = false;
    },
  },
};
</script>

<style lang="scss">
.my-referral {
  color: #fff;
  background-color: transparent;
  .card-header {
    background-image: linear-gradient(to top, #503161, rgba(70, 50, 100, 0)),
      linear-gradient(to bottom, #eb345f, #eb345f);
    justify-content: center;
  }
  .t-table {
    color: #fff;
    background-color: transparent;
    .title {
      background: linear-gradient(90deg, #472f6b 0%, rgba(71, 47, 107, 0) 100%);
      font-size: 30px;
      font-style: normal;
      font-weight: 600;
      line-height: 37px;
      padding: 6px 0 6px 58px;
      margin-bottom: 12px;
    }
    .t-header {
      color: white;
    }
    .t-tr-row {
      color: white;
    }
    .t-link {
      color: white;
    }
    .no-item {
      text-align: center;
      width: 100%;
      display: block;
      color: #8d3260;
      margin-top: 30px;
      margin-bottom: 60px;
      img {
        max-width: 80px;
      }
    }
  }

  .btn-create {
    padding: 8px 16px;
    border: none;
    font-weight: 700;
    color: #fff;
    background-image: linear-gradient(to top, #503161, rgba(70, 50, 100, 0)),
      linear-gradient(to bottom, #eb345f, #eb345f);
    border-bottom: 2px solid #eb345f;
    font-weight: 700;
    text-transform: uppercase;
    position: relative;
    clip-path: polygon(0 100%, 0 34%, 8% 0%, 100% 0, 100% 100%);
    &:focus,
    &:active {
      box-shadow: none;
    }
  }
  .btn-apply {
    border: none;
    font-weight: 700;
    color: #fff;
    background-image: linear-gradient(to top, #503161, rgba(70, 50, 100, 0)),
      linear-gradient(to bottom, #eb345f, #eb345f);
    border-bottom: 2px solid #eb345f;
    font-weight: 700;
    text-transform: uppercase;
    position: relative;
    clip-path: polygon(0 100%, 0 34%, 0% 0%, 100% 0, 100% 100%);
    &:focus,
    &:active {
      box-shadow: none;
    }
  }
}
</style>
